export const tr = {
    'different-protocols': 'Farklı',
    'site-link-descr': 'Açıklama',
    'site-link-different-values-placeholder': 'Seçilen reklamlar farklı değerlere sahip',
    'site-link-link': 'Site bağlantısı',
    'site-link-placeholder': 'Alan doldurulmalıdır',
    'site-link-title': 'Başlık',
    'site-link-turbo-error': 'Turbo sayfa belirtilmedi veya yanlış belirtildi'
};
